import React from 'react';
// import LayoutPage from "modules/layout/page";
import LayoutPage from 'modules/layout/LayoutPage';

export const PrivatePage = () => {
  return <LayoutPage />;
};

export default PrivatePage;
